import { render, staticRenderFns } from "./Project3.vue?vue&type=template&id=2c92bd4f&"
import script from "./Project3.vue?vue&type=script&lang=js&"
export * from "./Project3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports